import Vue from 'vue'
import Vuex from 'vuex'
import ibtStep from '@/constants/register/ibtStep'
import registerRepository from '@/repositories/register/registerRepository'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    // State
    currStep: ibtStep.confirmId,
    activeTab: ibtStep.confirmId,
    idInfoForm: null,
    idUploadForm: null,

    poiRecordId: null,
    poiPendingRecord: null,
    poiPendingReason: '',
    poiCustomPendingReason: '',

    poaRecordId: null,
    poaPendingRecord: null,
    poaPendingReason: '',
    poaCustomPendingReason: '',

    prevExistingIdAdvancedFilePathList: [],
    prevExistingPoaAdvancedFilePathList: [],
  }
}

export default new Vuex.Store({
  state: () => getDefaultState(),
  getters: {},
  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState())
    },
    setState(state, newState) {
      Object.assign(state, newState)
    },
  },
  actions: {
    setIdPendingInfo(
      { commit },
      { poiRecordId = null, poiPendingRecord = null, poiPendingReason = '', poiCustomPendingReason = '' }
    ) {
      commit('setState', { poiRecordId, poiPendingRecord, poiPendingReason, poiCustomPendingReason })
    },
    setPoaPendingInfo(
      { commit },
      { poaRecordId = null, poaPendingRecord = null, poaPendingReason = '', poaCustomPendingReason = '' }
    ) {
      commit('setState', { poaRecordId, poaPendingRecord, poaPendingReason, poaCustomPendingReason })
    },
    setStep({ commit }, step) {
      commit('setState', { currStep: step, activeTab: step })
    },
    setActiveTab({ commit }, tab) {
      commit('setState', { activeTab: tab })
    },
    setIdInfoForm({ commit }, idInfoForm) {
      commit('setState', { idInfoForm })
    },
    setIdUploadForm({ commit }, idUploadForm) {
      commit('setState', { idUploadForm })
    },
    async actionGetData({ commit }) {
      return new Promise(async resolve => {
        const response = await registerRepository.getData(5)
        if (!(response instanceof Error)) {
          // adding idDocFilePathList and poaDocFilePathList to avoid issue on previous exisitng user.
          const {
            idDocFilePathList,
            idAdvancedDocFilePathList,
            poaDocFilePathList,
            poaAdvancedDocFilePathList,
          } = response

          commit('setState', {
            prevExistingIdAdvancedFilePathList:
              idAdvancedDocFilePathList?.length > 0 || idDocFilePathList?.length > 0
                ? idAdvancedDocFilePathList || idDocFilePathList
                : [],
            prevExistingPoaAdvancedFilePathList:
              poaAdvancedDocFilePathList?.length > 0 || poaDocFilePathList?.length > 0
                ? poaAdvancedDocFilePathList || poaDocFilePathList
                : [],
          })
        }
        resolve(response)
      })
    },
  },
})
